export enum EventBusKey {
  UpdateNotification = "update-notification",
  Navigate = "navigate",
}
